export default {
  "open": "Ampliar imagen del hoyo {number}",
  "title": "{course} · Imagen del hoyo {number}",
  "back": "Volver a los resultados",
  "hole": "Hoyo {number}",
  "description": "{course} · Hoyo {number}",
  "loading": "Cargando imagen…",
  "error": "No se ha podido cargar la imagen.",
  "retry": "Reintentar",
  "zoom": "Ampliación de imagen",
  "out": "Reducir",
  "reset": "Restablecer ampliación",
  "in": "Ampliar"
}
